import { createTheme } from '@mui/material/styles';

export const colors = {};

export const customTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'white',
        },
      },
    },
  },
  palette: {
    primary: { main: '#F66F03' },
    secondary: { main: '#F6EDE5' },
    background: { main: '#F6EDE5' },
    text: { main: '#212121' },
    grey: { main: '#BBBBBB' },
  },
});
